/**
 * Features for product type smart.
 */
export enum LicenseQuestionnaireFeature {
  QUEST_RECORD = 'quest_record',
  QUEST_FULLVERSION = 'quest_fullversion',
  QUEST_RESULT = 'quest_result'
}
